module.exports = __webpack_public_path__ + "img/help.6beb04ff.svg";